/**
 * PromissoryNotesSubTab.jsx — Muhasebe FAZ 4.8, "Senetler" alt sekmesi.
 *
 * FAZ 3'te salt-okuma bir listeydi; FAZ 4 ile senet YAŞAM DÖNGÜSÜ ekranı
 * oldu. Üstte senet listesi (PromissoryNoteList — bağlam kaybolmasın diye
 * her sekmede görünür kalır), altta PLAN §822'nin 5 iç sekmesi:
 *
 *   1. Senet Parçala/Birleştir  → POST .../{id}/split · POST .../merge
 *   2. Senet Ekle               → POST /admin/promissory-notes
 *   3. Senet İptal              → POST .../{id}/cancel
 *   4. Avukat İşlemleri         → POST .../legal-transfer
 *   5. Senet Düzenleme          → PUT .../{id} · DELETE .../{id}
 *
 * ⚠️ S-16 kararı avukat görüşü beklediği için bu ekranın HİÇBİR yerinde
 * S-16 kapsamına giren süre sabiti, sayaç veya uyarı metni YOKTUR — Avukat
 * İşlemleri sekmesi dahil (bilinçli boşluk, unutulmuş değil).
 */
import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/tabs';
import { useLanguage } from '../../../contexts/LanguageContext';
import { LoadingState } from '../../../components/admin';
import PromissoryNoteList from './PromissoryNoteList';
import NoteSplitMergeTab from './NoteSplitMergeTab';
import NoteAddTab from './NoteAddTab';
import NoteCancelTab from './NoteCancelTab';
import NoteLegalTab from './NoteLegalTab';
import NoteEditTab from './NoteEditTab';

const NOTE_TABS = [
  { id: 'split_merge', key: 'accounting.notes_tabs.split_merge' },
  { id: 'add', key: 'accounting.notes_tabs.add' },
  { id: 'cancel', key: 'accounting.notes_tabs.cancel' },
  { id: 'legal', key: 'accounting.notes_tabs.legal_ops' },
  { id: 'edit', key: 'accounting.notes_tabs.edit' },
];

export default function PromissoryNotesSubTab({ detail, userId }) {
  const { t } = useLanguage();
  const [tab, setTab] = useState('split_merge');
  const [cancelPreselect, setCancelPreselect] = useState('');

  // `detail` üst bileşende yükleniyor olabilir (AdminStudentDetailPage) —
  // gelmeden liste/formlar boş veriyle çizilmesin.
  if (!detail) {
    return (
      <div className="flex items-center justify-center h-48">
        <LoadingState />
      </div>
    );
  }

  const notes = detail.promissory_notes || [];

  // "Senet Düzenleme" sekmesindeki "İptal Et" butonu -> İptal sekmesi.
  const requestCancel = (noteId) => {
    setCancelPreselect(noteId);
    setTab('cancel');
  };

  return (
    <div className="space-y-4">
      <PromissoryNoteList notes={notes} />

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="rounded-xl bg-[var(--bg-app)] border-2 border-[var(--border-light)] h-auto p-1 flex flex-wrap gap-1 mb-4 w-fit">
          {NOTE_TABS.map((item) => (
            <TabsTrigger
              key={item.id}
              value={item.id}
              className="rounded-lg text-xs font-bold px-3.5 py-1.5 data-[state=active]:bg-white data-[state=active]:text-[var(--brand-primary)] data-[state=active]:shadow-sm"
              data-testid={`note-subtab-${item.id}`}
            >
              {t(item.key)}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="split_merge" className="mt-0">
          <NoteSplitMergeTab userId={userId} notes={notes} />
        </TabsContent>

        <TabsContent value="add" className="mt-0">
          <NoteAddTab userId={userId} detail={detail} />
        </TabsContent>

        <TabsContent value="cancel" className="mt-0">
          <NoteCancelTab userId={userId} notes={notes} initialNoteId={cancelPreselect} />
        </TabsContent>

        <TabsContent value="legal" className="mt-0">
          <NoteLegalTab userId={userId} notes={notes} />
        </TabsContent>

        <TabsContent value="edit" className="mt-0">
          <NoteEditTab userId={userId} notes={notes} onRequestCancel={requestCancel} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
